export const currentDate = new Date();

export const dateFormatDay = 'DD';
export const dateFormatMonth = 'MM';
export const dateFormatYear = 'YYYY';

export const dateFormatFullYear = `${dateFormatYear}-${dateFormatMonth}-${dateFormatDay}`;
export const dateFormatFullMonth = `${dateFormatYear}-${dateFormatMonth}`;
